import React from 'react';
import { Helmet } from 'react-helmet-async';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';

export default function LegalPrivacy() {
  return (
    <>
      <Helmet>
        <title>Política de Privacidad | Inerva Psicología</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <Header />

      <main className="min-h-screen bg-cream pt-28 pb-20">
        <div className="container-narrow">
          <div className="max-w-3xl mx-auto bg-white rounded-2xl p-8 md:p-12 shadow-sm">
            <h1 className="text-3xl md:text-4xl mb-2 text-center">Política de Privacidad</h1>
            <p className="text-sm text-[var(--color-inerva-text-light)] text-center mb-10">
              Última actualización: 8 de agosto de 2025
            </p>

            <div className="prose prose-sm max-w-none prose-headings:font-serif prose-headings:text-[var(--color-inerva-forest)] prose-p:text-[var(--color-inerva-text)] prose-li:text-[var(--color-inerva-text)]">
              <h2>INFORMACIÓN AL USUARIO</h2>

              <h3>QUIÉN ES EL RESPONSABLE DE SUS DATOS PERSONALES</h3>
              <p>
                ELEVATE ESTUDIO S.L, es el responsable del tratamiento de los datos personales del usuario y le informa de que estos datos serán tratados de conformidad con lo dispuesto en el Reglamento (UE) 2016/679, de 27 de abril (GDPR), y la Ley Orgánica 3/2018, de 5 de diciembre (LOPDGDD).
              </p>

              <h3>PARA QUÉ TRATAMOS SUS DATOS PERSONALES Y POR QUÉ LO HACEMOS</h3>
              <p>
                Según cómo hayamos obtenido sus datos personales en el sitio web, los trataremos de manera confidencial para alcanzar los siguientes fines:
              </p>
              <ul>
                <li>Para dar respuesta a las consultas, agendar una reunión o cualquier tipo de petición realizada por el usuario a través de cualquiera de las formas de contacto que ponemos a su disposición en este sitio web (por el interés legítimo del responsable, art. 6.1.f GDPR).</li>
                <li>Para el envío de información comercial a aquellos usuarios que nos hayan facilitado su consentimiento para ello, o porque ya sean nuestros clientes (por el consentimiento del interesado, 6.1.a GDPR).</li>
              </ul>
              <p>Puede oponerse al envío de comunicaciones comerciales, dirigiéndose a nosotros a través de nuestro correo electrónico.</p>

              <h3>PRINCIPIOS APLICABLES AL TRATAMIENTO DE LOS DATOS PERSONALES</h3>
              <ul>
                <li><strong>Principio de licitud, lealtad y transparencia:</strong> Se requerirá en todo momento el consentimiento del usuario previa información completamente transparente de los fines para los cuales se recogen los datos personales.</li>
                <li><strong>Principio de limitación de la finalidad:</strong> Los datos personales serán recogidos con fines determinados, explícitos y legítimos.</li>
                <li><strong>Principio de minimización de datos:</strong> Los datos personales recogidos serán únicamente los estrictamente necesarios.</li>
                <li><strong>Principio de exactitud:</strong> Los datos personales deben ser exactos y estar siempre actualizados.</li>
                <li><strong>Principio de limitación del plazo de conservación:</strong> Los datos personales sólo serán mantenidos el tiempo necesario.</li>
                <li><strong>Principio de integridad y confidencialidad:</strong> Los datos personales serán tratados de manera que se garantice su seguridad.</li>
                <li><strong>Principio de responsabilidad proactiva:</strong> El responsable del tratamiento será responsable de asegurar que los principios anteriores se cumplen.</li>
              </ul>

              <h3>CONSERVACIÓN DE SUS DATOS PERSONALES</h3>
              <p>
                Sus datos personales se conservarán durante no más tiempo del necesario para mantener el fin del tratamiento o que existan prescripciones legales que dictaminen su custodia y cuando ya no sean necesarios para ello, se suprimirán con medidas de seguridad adecuadas para garantizar la anonimización de los datos o la destrucción total de los mismos.
              </p>

              <h3>DESTINATARIOS DE SUS DATOS PERSONALES</h3>
              <p>No está prevista ninguna comunicación de datos personales a terceros salvo, si fuese necesario para el desarrollo y ejecución de las finalidades del tratamiento.</p>

              <h3>CUÁLES SON SUS DERECHOS Y CÓMO EJERCITARLOS</h3>
              <p>
                Como interesado que nos ha proporcionado sus datos personales, tiene pleno derecho para ejercitar los siguientes derechos conforme a la normativa:
              </p>
              <ul>
                <li><strong>Derecho de Acceso:</strong> Solicitar y obtener gratuitamente la información de sus datos personales sometidos a tratamiento.</li>
                <li><strong>Derecho de Rectificación y Supresión:</strong> Corregir o eliminar los datos personales inexactos o no ajustados a la ley.</li>
                <li><strong>Derecho a la Limitación del tratamiento:</strong> Solicitar que sus datos sólo se conserven para determinados fines legítimos.</li>
                <li><strong>Derecho de Oposición:</strong> Oponerse en cualquier momento al tratamiento de sus datos personales.</li>
              </ul>
              <p>
                En caso de vulneración de sus derechos, el interesado tiene derecho a presentar una reclamación ante la Agencia Española de Protección de Datos (AEPD), en C/ Jorge Juan Nº6, 28001-Madrid, o en <a href="https://www.aepd.es" target="_blank" rel="noreferrer">www.aepd.es</a>.
              </p>

              <h3>DATOS DE CONTACTO PARA EJERCER SUS DERECHOS</h3>
              <ul>
                <li><strong>Denominación social:</strong> ELEVATE STUDIO S.L</li>
                <li><strong>CIF:</strong> B-75532226</li>
                <li><strong>Domicilio:</strong> C/ MARACENA Nº3, 18101-BELICENA (GRANADA)</li>
                <li><strong>Teléfono:</strong> 684053267</li>
                <li><strong>Email:</strong> info@elevate.com.es</li>
              </ul>

              <h3>CARÁCTER OBLIGATORIO O FACULTATIVO DE LA INFORMACIÓN</h3>
              <p>
                El usuario acepta expresamente y de forma libre e inequívoca que sus datos son necesarios para atender su petición.
                Garantiza que los datos personales facilitados son veraces y se compromete a comunicar cualquier modificación.
                Todos los datos solicitados son obligatorios; en caso de no facilitarlos, no se garantiza una atención adecuada.
              </p>

              <h3>MEDIDAS DE SEGURIDAD</h3>
              <p>
                El responsable cumple con todas las disposiciones del Reglamento (UE) 2016/679 (GDPR) y la Ley Orgánica 3/2018 (LOPDGDD), aplicando las medidas técnicas y organizativas necesarias para garantizar la seguridad, integridad y confidencialidad de los datos personales tratados.
              </p>

              <h3>REDES SOCIALES</h3>
              <p>
                El usuario puede acceder a las diferentes cuentas en redes sociales que el responsable tiene incluidas en este sitio web, aceptando el tratamiento de sus datos personales por parte de las mismas según sus políticas de privacidad.
                El responsable no se hace responsable de la información personal que cada usuario pueda publicar en dichas redes.
              </p>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </>
  );
}
